const Configloader = () => {
  const myHeaders = new Headers();
  myHeaders.append('pragma', 'no-cache');
  myHeaders.append('cache-control', 'no-cache');

  const myInit = {
    method: 'GET',
    headers: myHeaders,
  };

  return new Promise ((resolve, reject) => {
    fetch(`/config/config.json?${(new Date()).getTime()}`, myInit)
      .then(response => response.json())
      .then(response => resolve(response))
      .catch(err => {reject('Cannot load config.json')});
  })
};

export default Configloader;


// WEBPACK FOOTER //
// ./src/util/loader/Configloader.js